import axios from "axios";
import { SET_DATA } from "./types";

//Register Labels
export const setViewData = (type, data) => (dispatch) => {
  //   axios
  //     .get("/api/label")
  //     .then((res) => {
  //       if (res.data) {
  //         let temp = {};
  //         for (let key in res.data) {
  //           let str = res.data[key];
  //           temp[key] = str.split(",");
  //         }
  //         dispatch({
  //           type: SET_LABELS,
  //           payload: temp,
  //         });
  //       }
  //     })
  //     .catch((err) => {});
  dispatch({ type: SET_DATA, payload: { type: type, data: data } });
};
